import Enum from './enum'

class OrganizationType extends Enum
{
  constructor(value) {
    super(value);
  }
}

OrganizationType.init({
  NONE: 'None',
  PERSON: 'Person',
  ORGANIZATION: 'Organization',
  IP: 'Ip'
}, {
  NONE: 'org-type.none',
  PERSON: 'org-type.person',
  ORGANIZATION: 'org-type.organization',
  IP: 'org-type.ip'
});

export default OrganizationType;
